export const MAX_BANNER_FILE_SIZE = 1024 * 1024 // 1MB

export const DEFAULT_BANNER_URL = "https://firebasestorage.googleapis.com/v0/b/incentable-app-37d9c.appspot.com/o/system%2Fincentable_default_banner.png?alt=media&token=5a494429-1280-49d6-a6aa-324867fa0967";
export const REPLY_TO_EMAIL = "noreply@incentable.com";
